// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Lessons: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 88 60"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="88"
            height="60"
            fill="currentColor"
        >
            <path
                fillRule="evenodd"
                d="M136.106932,46.7702282 L137.217722,55.4863204 L137.288473,56.013665 C137.235916,57.0662984 135.873453,57.9441782 134.27347,57.9441782 C132.663379,57.9441782 131.300917,57.0539629 131.270595,55.9931058 L132.438997,46.7702282 L134.255277,46.7702282 C134.262352,46.7702282 134.268416,46.7722841 134.275491,46.7722841 C134.281556,46.7722841 134.28762,46.7702282 134.294695,46.7702282 L136.106932,46.7702282 Z M129.065185,39.8335386 L129.065185,20.8039008 L133.263752,19.081036 L133.263752,35.8563525 C131.223091,36.2510901 129.602893,37.8146207 129.065185,39.8335386 L129.065185,39.8335386 Z M99.0030827,54.8027255 C82.22903,54.8027255 70.9614269,49.6742216 70.9614269,44.8839174 L70.9614269,21.6344943 L99.0000505,33.1384203 L127.043728,21.6324384 L127.043728,44.8839174 C127.043728,49.6742216 115.777135,54.8027255 99.0030827,54.8027255 L99.0030827,54.8027255 Z M99.0000505,2.17002839 L137.177293,15.2590722 L99.0000505,30.9221336 L60.8238185,15.2590722 L99.0000505,2.17002839 Z M137.67154,41.2634342 C137.67154,43.1610526 136.157468,44.702996 134.294695,44.7143036 L134.255277,44.7143036 C132.392504,44.702996 130.878432,43.1610526 130.878432,41.2634342 C130.878432,39.3586201 132.402611,37.8084529 134.275491,37.8084529 C136.147361,37.8084529 137.67154,39.3586201 137.67154,41.2634342 L137.67154,41.2634342 Z M139.692997,41.2634342 C139.692997,38.5763408 137.790806,36.3405228 135.28622,35.8563525 L135.28622,18.2514704 L143.000101,15.0863745 L99.322473,0.111019927 L99.0000505,0 L55,15.0863745 L68.9399696,20.8049287 L68.9399696,44.8839174 C68.9399696,51.598567 82.1451395,56.85865 99.0030827,56.85865 C115.861026,56.85865 129.065185,51.598567 129.065185,44.8839174 L129.065185,42.6923018 C129.333028,43.6976489 129.863661,44.5878642 130.592396,45.2796828 L129.283502,55.4935161 C129.264299,55.6477105 129.248127,55.8008769 129.248127,55.9560992 C129.248127,58.1857494 131.502052,60.0001028 134.27347,60.0001028 C137.080263,60.0001028 139.292748,58.2330356 139.311952,55.9560992 L139.310941,55.879002 C139.305888,55.6261233 139.272534,55.3794123 139.21189,55.144009 L137.955554,45.2817388 C139.01783,44.2753637 139.692997,42.8516359 139.692997,41.2634342 L139.692997,41.2634342 Z"
                transform="translate(-55)"
            />
        </svg>
    );
};

export default React.memo(Lessons);
